<template>
  <div id="subprocessmap">
    <div class="container">
      <div class="row-fluid clearfix">
        <a @click="$router.go(-1)"> &lt; Back</a>
        <br>
        <div class="loading" v-if="loading===true">Loading&#8230;</div>
        <div class="w-100">
          <h3>Subprocess: {{current_process.name}}</h3>
          <h5>Type: {{(current_process.process_type) == 'S' ? 'DE SOPORTE' : (current_process.process_type) == 'C' ? 'CLAVE' : (current_process.process_type) == 'E' ? 'ESTRATEGICO' : ''}}</h5>
          <h5 v-if="current_process.parent">Parent: {{current_process.parent_name}}</h5>
        </div>
        <div class="loading" v-if="loading===true">Loading&#8230;</div>

        <v-btn 
          class="add-button"
          v-on:click="addProcessForm(current_process.standard, current_process.id)"
        >
          Add SubProcess
        </v-btn>
        <div ref="container"/>


      <!-- End of Process Map -->
      <v-dialog
        v-model="showEditProcessModal"
        scrollable
        persistent        
      >
        <v-card
          class="mx-auto"
          :loading="loading"
        >
          <v-card-title class="modal-card-title">
            <span  class="qmkey-modal-h1 pb-0">
              {{ edit_or_new }} SUBPROCESS {{ edit_process.name }}
            </span>
            <v-spacer></v-spacer>
            <v-btn
              text
              @click="closeProcessForm"
            >
              <v-icon small>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-form
              ref="editProcess"
              v-model="addProcessValid"
              autocomplete="off"
            >
              <v-alert
                :value="alert"
                color="error"
                dark
                icon="mdi-alert"
                transition="scale-transition"
                outlined
                dismissible
              >
                {{ message }}
              </v-alert>
              <v-row >
                <v-col>
                  <v-text-field
                    name="reference"
                    label="Reference"
                    id="reference"
                    autofocus
                    placeholder="Enter Reference"
                    v-model="edit_process.reference"
                    :rules="[rules.required]"
                    dense
                    class="qmkey-form-input"
                    outlined
                    background-color="#f2f2f2"
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    name="name"
                    label="Name"
                    id="name"
                    placeholder="Enter Name"
                    v-model="edit_process.name"
                    :rules="[rules.required]"
                    dense
                    class="qmkey-form-input"
                    outlined
                    background-color="#f2f2f2"
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-select
                    :items="process_types"
                    v-model="edit_process.process_type"
                    label="Process Type"
                    placeholder="Select Process type"
                    @change="onProcessTypeChange($event)" 
                    :required= "!process_type_read_only"
                    :readonly= "process_type_read_only"
                    dense
                    class="qmkey-form-input"
                    outlined
                    background-color="#f2f2f2"
                  >
                  </v-select>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col>
                  <v-textarea
                    auto-grow
                    loader-height="5"
                    dense
                    id="description"
                    label="Description"
                    name="description"
                    placeholder="Enter Process Description"
                    v-model="edit_process.description"
                    clearable
                    rows="5"
                    class="qmkey-form-input"
                    outlined
                    background-color="#f2f2f2"
                  >
                  </v-textarea>
                </v-col>
                <v-col>
                  <v-textarea
                    auto-grow
                    loader-height="5"
                    dense
                    id="entries"
                    label="Entries"
                    name="entries"
                    placeholder="Enter Entries"
                    v-model="edit_process.entries"
                    clearable
                    rows="5"
                    class="qmkey-form-input"
                    outlined
                    background-color="#f2f2f2"
                  >
                  </v-textarea>
                </v-col>
                <v-col>
                  <v-textarea
                    auto-grow
                    loader-height="5"
                    dense
                    id="outputs"
                    label="Outputs"
                    name="outputs"
                    placeholder="Enter Outputs"
                    v-model="edit_process.outputs"
                    clearable
                    rows="5"
                    class="qmkey-form-input"
                    outlined
                    background-color="#f2f2f2"
                  >
                  </v-textarea>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-textarea
                    auto-grow
                    loader-height="5"
                    dense
                    id="activities"
                    label="Activities"
                    name="activities"
                    placeholder="Enter Activities"
                    v-model="edit_process.activities"
                    clearable
                    rows="5"
                    class="qmkey-form-input"
                    outlined
                    background-color="#f2f2f2"
                  >
                  </v-textarea>
                </v-col>
                <v-col>
                  <v-textarea
                    auto-grow
                    loader-height="5"
                    dense
                    id="activities"
                    label="Process Object"
                    name="process_object"
                    placeholder="Enter Process Object"
                    v-model="edit_process.process_object"
                    clearable
                    rows="5"
                    class="qmkey-form-input"
                    outlined
                    background-color="#f2f2f2"
                  >
                  </v-textarea>
                </v-col>
                <v-col>
                  <v-textarea
                    auto-grow
                    loader-height="5"
                    dense
                    id="activities"
                    label="Scope"
                    name="scope"
                    placeholder="Enter Scope"
                    v-model="edit_process.scope"
                    clearable
                    rows="5"
                    class="qmkey-form-input"
                    outlined
                    background-color="#f2f2f2"
                  >
                  </v-textarea>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-select
                    :items="process_entries"
                    v-model="edit_process.process_entries"
                    label="Process Entries"
                    multiple
                    dense
                    class="qmkey-form-input"
                    outlined
                    background-color="#f2f2f2"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-select
                    :items="allRoles"
                    v-model="edit_process.responsible_roles"
                    placeholder="Roles that are responsibles of the Process"
                    label="Process Responsible Roles"
                    multiple
                    dense
                    class="qmkey-form-input"
                    outlined
                    background-color="#f2f2f2"
                  ></v-select>
                </v-col>
                <v-col>
                  <v-select
                    :items="allRoles"
                    v-model="edit_process.creator_roles"
                    placeholder="Roles that can create BPs implementing the Process"
                    label="Process Creator Roles"
                    multiple
                    dense
                    class="qmkey-form-input"
                    outlined
                    background-color="#f2f2f2"
                  ></v-select>
                </v-col>
                <v-col>
                  <v-select
                    :items="allRoles"
                    v-model="edit_process.editor_roles"
                    placeholder="Roles that can execute all transitions into QUnits implementing the Process"
                    label="Process Editor Roles"
                    multiple
                    dense
                    class="qmkey-form-input"
                    outlined
                    background-color="#f2f2f2"
                  ></v-select>
                </v-col>
                <v-col>
                  <v-select
                    :items="allRoles"
                    v-model="edit_process.reader_roles"
                    placeholder="Roles that can read ALL BPs implementing the Process"
                    label="Process Reader Roles"
                    multiple
                    dense
                    class="qmkey-form-input"
                    outlined
                    background-color="#f2f2f2"
                  ></v-select>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions class="qmkey-modal-dialog-card-actions">
            <v-spacer></v-spacer>
            <v-btn
              v-if="!process_type_read_only"
              class="qmkey-modal-dialog-button-submit"
              @click="addProcess"
              :disabled="!addProcessValid"
              small
            >
              Ok
            </v-btn>
            <v-btn
              v-if="process_type_read_only"
              class="qmkey-modal-dialog-button-submit"
              @click="editProcess"
              :disabled="!addProcessValid"
              small
            >
              OK Modify
            </v-btn>            
            <v-btn 
              small @click="clearEditProcess"
              class="qmkey-modal-dialog-button-secundary"
            >
              Clear
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>      
      <!-- Edit Permissions Modal -->
      <v-dialog
        v-model="showProcessRoles"
        persistent 
        transition="dialog-transition"
        scrollable
      >
        <v-card>
          <v-card-title class="modal-card-title">
            EDIT SUBPROCESS {{ edit_process.name }} ROLES
            <v-spacer></v-spacer>
            <v-btn
              text
              @click="closeProcessPermissionsForm"
            >
              <v-icon small>mdi-close</v-icon>
            </v-btn>
          </v-card-title>            
          <v-card-text>
            <v-form
              ref="editProcessPermissions"
              v-model="editProcessPermissionsValid"
              autocomplete="off"
            >
              <v-alert
                :value="alertRoles"
                color="error"
                dark
                icon="mdi-alert"
                transition="scale-transition"
                outlined
                dismissible
              >
                {{ message }}
              </v-alert>
              <v-row>
                <v-col>
                  Permission ID
                </v-col>
                <v-col>
                  Roles Allowed          
                </v-col>
                <v-col>
                  Departments Allowed
                </v-col>
                <v-col>
                  Actions
                </v-col>
              </v-row>
              <v-row 
                v-for="permission in edit_process.qprocesspermission_set" 
                :key="permission.id"
              >
                <v-col>
                  <input type="hidden" v-model="permission.id" />
                  <v-text-field
                    name="permission_id"
                    id="permission_id"
                    v-model="permission.permission_id"
                    readonly
                    class="qmkey-form-input"
                    outlined
                    background-color="#f2f2f2"
                    dense
                  >
                  </v-text-field>                  
                </v-col>
                <v-col>
                  <v-select
                    id="roles_allowed"
                    name="roles_allowed"
                    :items="allRoles"
                    v-model="permission.roles_allowed"
                    multiple
                    class="qmkey-form-input"
                    outlined
                    background-color="#f2f2f2"
                    dense
                  >
                  </v-select>                  
                </v-col>
                <v-col>
                  <v-select
                    id="departments_allowed"
                    name="departments_allowed"
                    :items="allDepartments"
                    v-model="permission.departments_allowed"                    
                    multiple
                    class="qmkey-form-input"
                    outlined
                    background-color="#f2f2f2"
                    dense
                  ></v-select>
                </v-col>
                <v-col>
                  <v-btn
                    class="btn-sm btn-danger qmkey-modal-dialog-button-secundary"
                    small
                    v-on:click="deletePermission(permission.id)"
                  >
                    Delete Role
                  </v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field
                    name="permission_id"
                    id="permission_id"
                    v-model="newPermission.permission_id"
                    required
                    :rules="[validatePermissionId]"
                    class="qmkey-form-input"
                    outlined
                    background-color="#f2f2f2"
                    dense
                  >
                  </v-text-field>                  
                </v-col>
                <v-col>
                  <v-select
                    id="roles_allowed"
                    name="roles_allowed"
                    :items="allRoles"
                    v-model="newPermission.roles_allowed"
                    multiple
                    class="qmkey-form-input"
                    outlined
                    background-color="#f2f2f2"
                    dense
                  >
                  </v-select>                  
                </v-col>
                <v-col>
                  <v-select
                    id="departments_allowed"
                    name="departments_allowed"
                    :items="allDepartments"
                    v-model="newPermission.departments_allowed"         
                    multiple
                    class="qmkey-form-input"
                    outlined
                    background-color="#f2f2f2"
                    dense
                  ></v-select>
                </v-col>
                <v-col>
                  <v-btn
                    class="qmkey-modal-dialog-button-submit"
                    text
                    v-on:click="addProcessPermission()"
                    :disabled="!validPermissionId"
                    small
                  >
                    Add Role
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              class="qmkey-modal-dialog-button-submit"
              text
              @click="editProcess"
              small
            >
              Ok
            </v-btn>
            <v-btn
              class="qmkey-modal-dialog-button-secundary"
              small
              @click="closeProcessPermissionsForm"
              color="#FFFFFF"
            >
              Cancel
            </v-btn>
          </v-card-actions>
        </v-card>        
      </v-dialog>
      <!-- End of edit permissions modal -->      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Roles from '@/api/Roles'

import {
  mxGraph as MxGraph,
  mxConstants,
  mxUtils,
  mxSwimlaneManager,
  mxStackLayout,
  mxLayoutManager,
  mxEvent,
  } from "mxgraph-js";

export default {
  name: 'qprocess_subprocessmap',
  cache: false,

  data: function() {
    return {
      loading: false,
      allRoles: [],
      allDepartments: [],
      message: null,
      current_process: {},
      newProcess: {},
      processes: [],
      graph_standard: null,
      graph_process: null,
      edit_process: {},
      newPermission: {},
      process_entries: [],
      process_types: [
        {
          text: 'Clave',
          value: 'C'
        },
        {
          value: 'E',
          text: 'Estratégico'
        },
        {
          value: 'S',
          text: 'De Soporte'
        }
      ],
      rules: {
        required: value => !!value || "Required.",
      },
      showEditProcessModal: false,
      loading: false,
      addProcessValid: false,
      alert: false,
      process_type_read_only: false,
      edit_or_new: '',
      showProcessRoles: false,
      alertRoles: false,
      editProcessPermissionsValid: false,
      validPermissionId: false
    }
  },
  computed: mapState(['sitePath']),
  created: function() {
    this.getProcess(this.$route.query.id)
  },
  mounted: function(){
    this.getProcesses()
    this.getRoles()
    this.getDepartments()
  },
  beforeRouteUpdate (to, from, next) {
    this.curret_process = this.getProcess(to.query.id)
    this.getProcesses()
    next()
  },
  methods: {
    async getRoles() {
      await Roles.get(this.sitePath)
        .then(response => {
          this.allRoles = []
          for (var role of response.results) {
            this.allRoles.push({ value: role.id, text: role.name })
          }
        })
        .catch(err => {
          this.render_form_errors(err)
        })
    },
    async getDepartments() {
      this.loading = true
      await this.$http
        .get(
          this.$base + '/api/v1' + this.$session.get('site') + '/department/',
        )
        .then(response => {
          this.allDepartments = []
          for (var dep of response.data['results']) {
            this.allDepartments.push({ value: dep.id, text: dep.name })
          }
          this.loading = false
        })
        .catch(err => {
          this.render_form_errors(err)
      })
    },
    initGraph() {
            if(this.graph)
                this.graph.destroy()

            this.graph = new MxGraph(this.$refs.container);

            var model = this.graph.getModel();

            var style = this.graph.getStylesheet().getDefaultVertexStyle();
            style[mxConstants.STYLE_SHAPE] = mxConstants.SHAPE_SWIMLANE;
            style[mxConstants.STYLE_VERTICAL_ALIGN] = "middle";
            style[mxConstants.STYLE_LABEL_BACKGROUNDCOLOR] = "white";
            style[mxConstants.STYLE_FONTSIZE] = 25;
            style[mxConstants.STYLE_STARTSIZE] = 80;
            style[mxConstants.STYLE_HORIZONTAL] = false;
            style[mxConstants.STYLE_FONTCOLOR] = "black";
            style[mxConstants.STYLE_STROKECOLOR] = "black";
            style[mxConstants.STYLE_FILLCOLOR] = "lightblue";
            style[mxConstants.STYLE_LABEL_BACKGROUNDCOLOR] = "none";

            style = mxUtils.clone(style);
            style[mxConstants.STYLE_SHAPE] = mxConstants.SHAPE_RECTANGLE;
            style[mxConstants.STYLE_FONTSIZE] = 15;
            style[mxConstants.STYLE_ROUNDED] = true;
            style[mxConstants.STYLE_HORIZONTAL] = true;
            style[mxConstants.STYLE_VERTICAL_ALIGN] = "middle";
            delete style[mxConstants.STYLE_STARTSIZE];
            style[mxConstants.STYLE_LABEL_BACKGROUNDCOLOR] = "none";
            style[mxConstants.STYLE_FILLCOLOR] = "lightblue";
            this.graph.getStylesheet().putCellStyle("process", style);

            if (this.graph.isEnabled())
      {
                this.graph.isPool = function(cell)
                {
                    var model = this.getModel();
                    var parent = model.getParent(cell);
                
                    return parent != null && model.getParent(parent) == model.getRoot();
                };
            }
            
            new mxSwimlaneManager(this.graph);
            
            mxEvent.disableContextMenu(document.body);
            
            var layout = new mxStackLayout(this.graph, false);
            layout.resizeParent = true;
            layout.fill = true;
            layout.isVertexIgnored = function(vertex)
            {
                return !this.graph.isSwimlane(vertex);
            }

            var layoutMgr = new mxLayoutManager(this.graph);
            layoutMgr.getLayout = function(cell)
            {
                if (!model.isEdge(cell) && this.graph.getModel().getChildCount(cell) > 0 &&
                    (model.getParent(cell) == model.getRoot() || this.graph.isPool(cell)))
                {
                    layout.fill = this.graph.isPool(cell);
                    
                    return layout;
                }
                
                return null;
            };

            let component = this
            this.graph.popupMenuHandler.factoryMethod = function(menu, cell)
        {
                    if(!this.graph.isPool(cell) && !this.graph.isSwimlane(cell) && cell != null)
                    {
                        menu.addItem('Show Details', require('../assets/menu/search.png'), function(){
                            component.showDetails(cell.id)
                        });
                        
                        menu.addItem('Edit Process', require('../assets/menu/edit.png'), function()
                        {
                            component.editProcessForm(cell.id)
                        });
                        
                        menu.addItem('Delete Process', require('../assets/menu/delete.png'), function()
                        {
                            component.deleteProcess(cell.id)
                        });

                        menu.addItem('Process Permissions', require('../assets/menu/permission.png'), function()
                        {
                            component.editProcessForm(cell.id, 'permissions')
                        });
                    }
        };

            this.graph.addListener(mxEvent.DOUBLE_CLICK, function (sender, evt) {
                
                var cell = evt.getProperty("cell"); 
                if (cell != null && (!sender.isPool(cell) && !sender.isSwimlane(cell))) {
                    component.showDetails(cell.id)
                }
                evt.consume();
            });

            this.parent = this.graph.getDefaultParent();

            this.graph.getModel().beginUpdate();
            try {
                this.graph_standard = this.graph.insertVertex(this.parent, null, this.current_process.standard_name, 0,0,1000,0);
                this.graph_standard.setConnectable(false);

                this.graph_process = this.graph.insertVertex(this.graph_standard,null,this.current_process.name,0,0,1000,350);
                this.graph_process.setConnectable(false);
            } finally {
                this.graph.getModel().endUpdate();
                this.graph.setEnabled(false);
            }
    },
    async getProcess(id){
      this.loading = true
      this.message = ''
      await this.$http
        .get(
          this.$base 
          + '/api/v1' 
          + this.$session.get('site') 
          + '/process/' 
          + id 
          + '/',
        )
        .then(response => {
          this.current_process = response.data
          // this.updateStandardAspects()
          // this.$refs.modalstandard.show()
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          alert(err)
        })
    },
    async getProcesses() {
      this.loading = true
      await this.$http
        .get(this.$base + '/api/v1' + this.$session.get('site') + '/process/')
        .then(response => {
          this.processes = response.data['results']
          if (this.edit_process) {
            for (var i = 0; i < this.processes.length; i++) {
              var proc = this.processes[i]
              if (this.edit_process.id == proc.id) {
                this.edit_process = proc
              }
            }
          }
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          alert(err)
        })
    },
    showDetails: function(id){
      this.$router.push({ name: 'subprocess', query: { id: id }});
    },
    addProcessForm: function(standard_id, parent_id) {
        this.message = ''
        this.current_standard_id = standard_id
        // this.updateStandardAspects()
        this.edit_process = {}
        this.edit_process.standard = standard_id
        this.edit_process.parent = parent_id
        this.edit_process.responsible_roles = new Array()
        this.edit_process.creator_roles = new Array()
        this.edit_process.reader_roles = new Array()
        this.edit_process.editor_roles = new Array()
        this.edit_process.process_type = null
        this.process_entries = new Array()
        // this.$refs.addmodalProcess.show()
        this.process_type_read_only = false
        this.edit_or_new = 'New'
        this.showEditProcessModal = true
    },
    async addProcess(evt) {
      if (evt) evt.preventDefault()
      this.loading = true
      this.message = ''
      await this.$http
        .post(
          this.$base + '/api/v1' + this.$session.get('site') + '/process/',
          this.edit_process,
        )
        .then(() => {
          // this.$refs.addmodalProcess.hide()
          this.showEditProcessModal = false
          this.showProcessRoles  = false
          this.getProcesses()
          this.loading = false
        })
        .catch(err => {
          this.render_form_errors(err)
        })
    },
    async editProcessForm(qprocess_id, dest) {
      this.loading = true
      this.message = ''
      await this.$http
        .get(
          this.$base +
              '/api/v1' +
              this.$session.get('site') +
              '/process/' +
              qprocess_id +
              '/',
          )
        .then(response => {
          this.edit_process = response.data
          this.current_standard_id = this.edit_process.standard
          // this.updateStandardAspects()
          this.loading = false
          this.process_type_read_only = true
          if (dest == 'permissions'){
            // this.$refs.permissionsModal.show()
            this.showProcessRoles = true
          } 
          else {
            this.updateProcessEntriesList(
              this.edit_process.process_type, 
              this.edit_process.id
            )
            this.edit_or_new = 'Edit'
              // this.$refs.editmodalProcess.show()
              this.showEditProcessModal = true
          }
        })
        .catch(err => {
          this.loading = false
          alert(err)
        })
    },
    async editProcess(evt) {
      if (evt) evt.preventDefault()
      this.loading = true
      this.message = ''
      await this.$http.put(
        this.$base +
          '/api/v1' +
          this.$session.get('site') +
          '/process/' +
          this.edit_process.id +
          '/',
        this.edit_process,
      )
      .then(() => {
        this.loading = false
        this.getProcesses()
        this.showEditProcessModal = false
      })
      .catch(err => {
        this.render_form_errors(err)
      })
    },
    async deleteProcess(id) {
      if (confirm('Are you sure you want to delete this process?')) {
      this.loading = true
      this.message = ''
      await this.$http
        .delete(
          this.$base +
          '/api/v1' +
          this.$session.get('site') +
          '/process/' +
          id +
          '/',
        )
        .then(() => {
          this.loading = false
          this.getProcesses()
        })
        .catch(err => {
          this.render_form_errors(err)
        })
      }
    },
    async deletePermission(id) {
      if (confirm('Are you sure you want to delete this process role?')) {
        this.loading = true
        this.message = ''
        await this.$http
          .delete(
            this.$base +
            '/api/v1' +
            this.$session.get('site') +
            '/processpermission/' +
            id +
            '/',
          )
          .then(() => {
            this.loading = false
            this.getProcesses()
          })
          .catch(err => {
            this.render_form_errors(err)
          })
      }
    },    
    async addProcessPermission(evt) {
      if (evt) evt.preventDefault()

      if (!this.newPermission.permission_id) {
        this.message = "Permission ID couldn't be empty"
        return
      }
      this.loading = true
      this.message = ''
      this.newPermission.process = this.edit_process.id
      await this.$http
        .post(
          this.$base +
            '/api/v1' +
            this.$session.get('site') +
            '/processpermission/',
          this.newPermission,
        )
        .then(() => {
          this.loading = false
          this.getProcesses()
          this.newPermission = {}
        })
        .catch(err => {
          this.render_form_errors(err)
        })
    },    
    onProcessTypeChange: function(evt){
        this.updateProcessEntriesList(evt)
    },
    updateProcessEntriesList(process_type, id){
      this.process_entries = []
      this.processes.filter(p => p.parent == null && p.process_type == process_type && p.id != id).forEach(pe => {
            this.process_entries.push({value: pe.id, text: pe.name})
      })
    },
    clearEditProcess: function() {
      this.message = '';
      this.alert = false;
      this.$refs.editProcess.resetValidation()
      this.currentMenu = {}
    },
    closeProcessForm: function() {
      this.$refs.editProcess.reset()
      this.message = '';
      this.alert = false;
      this.showEditProcessModal = false
      this.edit_process = {}
    },
    clearEditProcessPermissions: function() {
      this.message = '';
      this.alert = false;
      this.$refs.editProcessPermissions.resetValidation()
      this.currentMenu = {}
    },
    closeProcessPermissionsForm: function() {
      this.$refs.editProcessPermissions.reset()
      this.message = '';
      this.alert = false;
      this.showProcessRoles = false
      this.edit_process = {}
    },
    validatePermissionId: function(value){
      console.log('validatePermissionId', value)
      if ( !value ) {
        this.validPermissionId = false
        return 'Could not be empty'
      }
      var v = true
      this.validPermissionId = true
      // for (var permission in this.edit_process.qprocesspermission_set)
      var permissions = this.edit_process.qprocesspermission_set
      var permission = null
      for (var i=0; i<permissions.length; i++){
        permission = this.edit_process.qprocesspermission_set[i]
        console.log(permission, permission.permission_id, value)
        if (value == permission.permission_id){
          this.validPermissionId = false
          v = 'Duplicated'
          break
        }
      }
      return v
    },
  },
  watch:{
      processes(newValue, oldValue){
          this.graph.getModel().beginUpdate();
          var subprocesses_old = oldValue.filter(x=> x.parent != null && x.parent == this.current_process.id);
          subprocesses_old.forEach(p => {
                  this.graph.getModel().remove(this.graph.getModel().getCell(p.id))
          })

          var subprocesses = newValue.filter(x => x.parent != null && x.parent == this.current_process.id);
          try {
              var x = 100;
              subprocesses.forEach(p => {
                  this.graph.insertVertex(this.graph_process, p.id, p.name, x, 60, p.name.length * 9, 50, 'process');
                  x = x + p.name.length * 9 + 50;
              });

              // Adding entries
              subprocesses.forEach(p => {
                  if(p.process_entries.length > 0)
                  {
                      p.process_entries.forEach(pe => {
                          
                          var cellS = this.graph.getModel().getCell(String(pe))
                          var cellD = this.graph.getModel().getCell(String(p.id))
                          this.graph.insertEdge(this.parent, null, "", cellS, cellD);
                      });
                  }
              });
          }
          finally{
              this.graph.getModel().endUpdate();
          }
      },
      current_process(){
          this.initGraph()
      },
  }
}
</script>


<style lang="scss">
  @import "@/sass/processmap.scss";
  @import '@/sass/modalform.scss';
</style>
